export enum ProgressBarBackgroundType {
  Default = 'default',
  Primary = 'primary',
};
